import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivacyPolicy from "../pages/privacy/page";
import TermsConditions from "../pages/terms/page";
import RefundPolicy from "../pages/refund/page";
import AboutPage from "../pages/about/page";
import SitemapPage from "../pages/sitemap/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    element: <TermsConditions />,
  },
  {
    path: "/refund",
    element: <RefundPolicy />,
  },
  {
    path: "/sitemap",
    element: <SitemapPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
